export default {"src":"/_next/static/media/active-indicator-green.0cc8bebb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};